const E = Symbol("Error<SESSION_EXPIRED>"), S = Symbol("Error<SESSION_FACTORY_UNAVAILABLE>"), _ = Symbol("Error<SESSION_HTTP_UNAVAILABLE>"), R = Symbol("Error<SESSION_INVALID>"), s = Symbol("Error<SESSION_REFRESH_ABORTED>"), I = "_sessionExpired", o = "_sessionReady", N = "_sessionRefreshed", r = "_sessionRefreshingEnd", A = "_sessionRefreshingStart";
export {
  E as ERR_SESSION_EXPIRED,
  S as ERR_SESSION_FACTORY_UNAVAILABLE,
  _ as ERR_SESSION_HTTP_UNAVAILABLE,
  R as ERR_SESSION_INVALID,
  s as ERR_SESSION_REFRESH_ABORTED,
  I as EVT_SESSION_EXPIRED,
  o as EVT_SESSION_READY,
  N as EVT_SESSION_REFRESHED,
  r as EVT_SESSION_REFRESHING_END,
  A as EVT_SESSION_REFRESHING_START
};
